export const consultationsTranslations = {
  fr: {
    // Navigation et pages
    consultations: "Consultations",
    newConsultation: "Nouvelle consultation", 
    editConsultation: "Modifier la consultation",
    patientDetails: "Fiche patient",
    patientNotFound: "Patient non trouvé",
    
    // Page Consultations
    seoTitle: "Gestion des Consultations - Sclépios I.A",
    seoDesc: "Gérez vos patients et consultations médicales avec l'assistant IA Sclépios",
    myPatients: "Mes Patients",
    newPatient: "Nouveau Patient",
    newPatientShort: "Nouveau",
    searchPatient: "Rechercher un patient...",
    results: "{{count}} résultat(s)",
    filters: "Filtres",
    noPatientFound: "Aucun patient trouvé",
    noPatientRegistered: "Aucun patient enregistré",
    tryModifySearch: "Essayez de modifier votre recherche",
    addFirstPatient: "Commencez par ajouter votre premier patient",
    addPatient: "Ajouter un patient",
    
    // Cotations
    cim10Title: "Codes CIM-10 (Diagnostics)",
    ccamTitle: "Codes CCAM (Actes)",
    codePlaceholder: "Code {{type}}",
    labelPlaceholder: "Libellé",
    
    // Informations patient
    patientInfo: "Informations patient",
    birthDate: "Date de naissance",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    attendingPhysician: "Médecin traitant",
    
    // Statuts
    status: {
      brouillon: "Brouillon",
      terminé: "Terminé"
    },
    
    // Actions
    createFirst: "Créer la première consultation",
    noConsultations: "Aucune consultation enregistrée",
    consultationsDescription: "Historique des consultations pour ce patient",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette consultation ?",
    deleted: "Consultation supprimée",
    saved: "Consultation sauvegardée",
    codeAdded: "Code {{type}} ajouté",
    codeRemoved: "Code {{type}} supprimé",
    updated: "Consultation mise à jour",
    loadError: "Erreur lors du chargement des consultations",
    loadOneError: "Erreur lors du chargement de la consultation",
    deleteError: "Erreur lors de la suppression",
    saveError: "Erreur lors de la sauvegarde",
    complete: "Terminer",
    labelOptional: "Libellé (optionnel)",
    justificationOptional: "Justification (optionnelle)",
    addCode: "Ajouter un code {{type}}",
    usualTreatment: "Traitement habituel",
    cim10Code: "CIM-10",
    
    // Sections de consultation
    freeText: "Texte libre",
    freeTextPlaceholder: "Saisissez ici vos notes libres de consultation...",
    history: "Histoire de la maladie",
    historyPlaceholder: "Motif de consultation, évolution des symptômes...",
    background: "Antécédents",
    backgroundPlaceholder: "Antécédents médicaux, chirurgicaux, familiaux...",
    clinicalObservation: "Observation clinique",
    clinicalObservationPlaceholder: "Examen physique, signes cliniques...",
    paraclinicalResults: "Résultats paracliniques", 
    paraclinicalResultsPlaceholder: "Examens complémentaires, analyses...",
    conclusions: "Conclusion",
    conclusionsPlaceholder: "Diagnostic, traitement, recommandations...",
    
    // IA et transcription
    analyzeWithAI: "Analyser par IA",
    noTextToAnalyze: "Aucun texte à analyser",
    
    // Entry tiles
    entryTiles: {
      text: {
        title: "Saisie textuelle",
        desc: "Tapez vos notes."
      },
      voice: {
        title: "Dictée vocale", 
        desc: "Appuyez pour dicter, nous transcrivons."
      },
      photo: {
        title: "Prise de photo",
        desc: "Prenez un document en photo, nous extrayons le texte."
      },
      import: {
        title: "Import de documents",
        desc: "Importez vos documents, texte extrait automatiquement."
      }
    },
    preFilledFromLatest: "Éléments pré-remplis depuis la dernière consultation",
    aiAnalysisComplete: "Analyse IA terminée",
    aiAnalysisError: "Erreur lors de l'analyse IA",
    aiOfflineError: "L'analyse IA n'est pas disponible hors ligne",
    audioTranscription: "Transcription audio",
    transcriptionAdded: "Transcription ajoutée",
    
    // Sauvegarde et offline
    savedOffline: "Sauvegardé localement (sera synchronisé en ligne)",
    
    // Export
    copyText: "Copier le texte",
    printPDF: "Imprimer en PDF",
    copiedToClipboard: "Copié dans le presse-papiers",
    nothingToCopy: "Rien à copier",
    
    // New UI translations
    tabs: {
      saisie: "Saisie",
      structuration: "Structuration", 
      synthese: "Synthèse"
    },
    actions: {
      analyze: "Analyser par IA",
      copy: "Copier",
      print: "Imprimer",
      save: "Enregistrer",
      complete: "Terminer",
      saveStatus: {
        saving: "Sauvegarde...",
        saved: "Sauvegardé",
        offline: "Mode hors ligne"
      },
      shortcuts: {
        save: "Ctrl+S pour enregistrer",
        analyze: "Ctrl+Entrée pour analyser"
      }
    },
    ocr: {
      extractedText: "Texte extrait par OCR",
      ocrDocument: "Document OCR"
    },
    offline: {
      available: "Disponible hors ligne",
      notAvailable: "Non disponible hors ligne"
    },
    toc: {
      title: "Sommaire",
      saisieLibre: "Saisie libre",
      voiceRecording: "Transcription vocale",
      ocr: "Extraction de document",
      attachments: "Pièces jointes",
      histoireMaladie: "Histoire de la maladie", 
      antecedents: "Antécédents",
      traitement: "Traitement habituel",
      modeDeVie: "Mode de vie",
      allergies: "Allergies",
      observation: "Observation clinique",
      priseEnCharge: "Prise en charge",
      resultatsParacliniques: "Résultats paracliniques",
      ordonnancesSortie: "Ordonnances de sortie",
      cotations: "Codage",
      conclusion: "Conclusion",
      ccmu: "Classification CCMU",
      facturation: "Facturation",
      valorisation: "Valorisation",
      courrierLiaison: "Courrier de liaison"
    },
    tips: {
      voiceRecording: "Conseil : utilisez l'enregistrement vocal pour une saisie rapide",
      ocrUpload: "Astuce : uploadez des documents pour extraction automatique du texte"
    },
    placeholders: {
      freeText: 'Saisissez ici le motif de consultation, les symptômes, l\'examen clinique...',
      history: 'Décrivez l\'évolution des symptômes, les traitements antérieurs...',
      background: 'Antécédents médicaux, chirurgicaux, familiaux...',
      observation: 'Examen physique, signes vitaux...',
      management: 'Diagnostic, plan thérapeutique...',
      results: 'Résultats des examens complémentaires...',
      conclusion: 'Synthèse de la consultation, recommandations...',
      prescriptions: 'Ordonnances de sortie...',
      synthesis: 'Saisissez ou générez automatiquement le courrier de liaison...',
      antecedentsStructures: 'Ajoutez les antécédents médicaux, chirurgicaux et comorbidités...',
      traitementHabituel: 'Listez les médicaments habituels du patient...',
      modeDeVie: 'Notez les habitudes de vie, facteurs de risque...',
      allergies: 'Listez les allergies connues du patient...',
      priseEnCharge: "Traitement proposé, surveillance, orientation...",
      coding: 'Codes CIM-10 et CCAM générés par l\'IA...',
    },
    ordonnances: {
      medicaments: "Médicaments",
      materiel: "Matériel médical",
      imagerie: "Imagerie",
      biologie: "Examens biologiques",
      medicationPlaceholder: "Médicament (DCI) + posologie",
      equipmentPlaceholder: "Matériel médical",
      imagingPlaceholder: "Examen d'imagerie",
      biologyPlaceholder: "Examen biologique",
      medications: "Médicaments",
      equipment: "Matériel",
      imaging: "Imagerie",
      biology: "Biologie",
    },
    synthesis: {
      title: "Courrier de liaison",
      placeholder: "Rédigez ici le courrier de liaison structuré...",
      generate: "Générer automatiquement",
      regenerate: "Régénérer",
      generated: "Courrier de liaison généré",
      export: "Exporter en PDF"
    },
    copy: {
      section: "Copier la section",
      copied: "Section copiée",
      error: "Erreur lors de la copie"
    },
    characterCount: "caractères",
    onboarding: {
      title: "Configuration du module consultation",
      description: "Pour optimiser votre expérience, veuillez compléter vos informations professionnelles. Ces données amélioreront la génération automatique de documents et la facturation.",
      professionalInfo: "Informations professionnelles",
      proPhone: "Téléphone professionnel",
      phonePlaceholder: "01 23 45 67 89",
      proEmail: "Email professionnel",
      emailPlaceholder: "docteur@cabinet.fr",
      proAddress: "Adresse professionnelle",
      proAddressPlaceholder: "Adresse complète de votre cabinet médical...",
      rpps: "Numéro RPPS",
      rppsPlaceholder: "12345678901",
      benefits: {
        title: "Avantages de ces informations :",
        letters: "Courriers de liaison personnalisés",
        documents: "Documents officiels pré-remplis"
      },
      skip: "Passer pour le moment",
      save: "Enregistrer et continuer",
      saving: "Enregistrement...",
      saved: "Informations professionnelles enregistrées",
      privacy: "Ces informations sont stockées de manière sécurisée et ne sont utilisées que pour améliorer votre expérience."
    },
    editor: {
      draftCreated: "Brouillon créé automatiquement",
      draftError: "Erreur lors de la création du brouillon",
      codeRequired: "Le code est obligatoire",
      ocrTextAdded: "Texte extrait des documents ajouté",
      noTextForAI: "Aucun texte disponible pour l'analyse IA",
      largeTextWarning: "Texte volumineux détecté - Compression automatique en cours...",
      pdfError: "Erreur lors de la génération du PDF",
      printWindowError: "Impossible d'ouvrir la fenêtre d'impression",
      codeCopied: "Code {{type}} copié"
    }
  },
  
  en: {
    // Navigation and pages  
    consultations: "Consultations",
    newConsultation: "New consultation",
    editConsultation: "Edit consultation", 
    patientDetails: "Patient details",
    patientNotFound: "Patient not found",
    
    // Consultations page
    seoTitle: "Consultation Management - Sclépios I.A",
    seoDesc: "Manage your patients and medical consultations with the AI assistant Sclépios",
    myPatients: "My Patients",
    newPatient: "New Patient",
    newPatientShort: "New",
    searchPatient: "Search for a patient...",
    results: "{{count}} result(s)",
    filters: "Filters",
    noPatientFound: "No patient found",
    noPatientRegistered: "No registered patients",
    tryModifySearch: "Try modifying your search",
    addFirstPatient: "Start by adding your first patient",
    addPatient: "Add a patient",
    
    // Cotations
    cim10Title: "ICD-10 Codes (Diagnoses)",
    ccamTitle: "CCAM Codes (Procedures)",
    codePlaceholder: "{{type}} code",
    labelPlaceholder: "Label",
    
    // Patient information
    patientInfo: "Patient information",
    birthDate: "Birth date",
    phone: "Phone",
    email: "Email", 
    address: "Address",
    attendingPhysician: "Attending physician",
    
    // Status
    status: {
      brouillon: "Draft",
      terminé: "Completed"
    },
    
    // Actions
    createFirst: "Create first consultation",
    noConsultations: "No consultations recorded",
    consultationsDescription: "Consultation history for this patient",
    confirmDelete: "Are you sure you want to delete this consultation?",
    deleted: "Consultation deleted",
    saved: "Consultation saved",
    codeAdded: "{{type}} code added",
    codeRemoved: "{{type}} code removed",
    updated: "Consultation updated",
    loadError: "Error loading consultations",
    loadOneError: "Error loading consultation",
    deleteError: "Error deleting consultation",
    saveError: "Error saving consultation",
    complete: "Complete",
    labelOptional: "Label (optional)",
    justificationOptional: "Justification (optional)",
    addCode: "Add {{type}} code",
    usualTreatment: "Usual treatment",
    cim10Code: "ICD-10",
    
    // Consultation sections
    freeText: "Free text",
    freeTextPlaceholder: "Enter your consultation notes here...",
    history: "History of present illness",
    historyPlaceholder: "Chief complaint, symptom evolution...",
    background: "Medical history",
    backgroundPlaceholder: "Past medical, surgical, family history...",
    clinicalObservation: "Clinical observation", 
    clinicalObservationPlaceholder: "Physical examination, clinical signs...",
    paraclinicalResults: "Paraclinical results",
    paraclinicalResultsPlaceholder: "Laboratory tests, imaging...",
    conclusions: "Conclusions and prescriptions",
    conclusionsPlaceholder: "Diagnosis, treatment, recommendations...",
    
    // AI and transcription
    analyzeWithAI: "Analyze with AI",
    noTextToAnalyze: "No text to analyze",
    
    // Entry tiles
    entryTiles: {
      text: {
        title: "Text Input",
        desc: "Type your notes."
      },
      voice: {
        title: "Voice Dictation", 
        desc: "Tap to dictate; we transcribe."
      },
      photo: {
        title: "Photo Capture",
        desc: "Take a photo of a document; we extract the text."
      },
      import: {
        title: "Document Import",
        desc: "Import documents; text extracted automatically."
      }
    },
    aiAnalysisComplete: "AI analysis completed",
    aiAnalysisError: "AI analysis error",
    audioTranscription: "Audio transcription",
    transcriptionAdded: "Transcription added",
    
    // Export
    copyText: "Copy text",
    printPDF: "Print to PDF",
    copiedToClipboard: "Copied to clipboard",
    nothingToCopy: "Nothing to copy",
    
    // New UI translations
    tabs: {
      saisie: 'Entry',
      structuration: 'Structure',
      synthese: 'Synthesis'
    },
    actions: {
      analyze: 'Analyze with AI',
      copy: 'Copy',
      print: 'Print',
      save: 'Save',
      complete: 'Complete',
      saveStatus: {
        saving: 'Saving...',
        saved: 'Saved',
        offline: 'Offline mode'
      },
      shortcuts: {
        save: 'Ctrl+S to save',
        analyze: 'Ctrl+Enter to analyze'
      }
    },
    ocr: {
      extractedText: "OCR extracted text",
      ocrDocument: "OCR Document"
    },
    offline: {
      available: "Available offline",
      notAvailable: "Not available offline"
    },
    toc: {
      title: "Table of Contents",
      saisieLibre: "Free entry",
      voiceRecording: "Voice transcription",
      ocr: "Document extraction",
      attachments: "Attachments",
      histoireMaladie: "History of illness", 
      antecedents: "History",
      traitement: "Regular treatment",
      modeDeVie: "Lifestyle",
      allergies: "Allergies",
      observation: "Clinical observation",
      priseEnCharge: "Management",
      resultatsParacliniques: "Paraclinical results",
      ordonnancesSortie: "Discharge prescriptions",
      cotations: "Coding",
      conclusion: "Conclusion",
      ccmu: "CCMU Classification",
      facturation: "Billing",
      valorisation: "Valuation",
      courrierLiaison: "Liaison letter"
    },
    tips: {
      voiceRecording: "Tip: use voice recording for quick entry",
      ocrUpload: "Tip: upload documents for automatic text extraction"
    },
    placeholders: {
      freeText: 'Enter the reason for consultation, symptoms, clinical examination...',
      history: 'Describe symptom evolution, previous treatments...',
      background: 'Medical, surgical, family history...',
      observation: 'Physical examination, vital signs...',
      management: 'Diagnosis, treatment plan...',
      results: 'Complementary examination results...',
      conclusion: 'Consultation summary, recommendations...',
      prescriptions: 'Discharge prescriptions...',
      synthesis: 'Enter or automatically generate the liaison letter...',
      antecedentsStructures: 'Add medical, surgical history and comorbidities...',
      traitementHabituel: 'List patient\'s regular medications...',
      modeDeVie: 'Note lifestyle habits, risk factors...',
      allergies: 'List known patient allergies...',
      priseEnCharge: "Proposed treatment, monitoring, referral...",
      coding: 'CIM-10 and CCAM codes generated by AI...',
    },
    ordonnances: {
      medicaments: "Medications",
      materiel: "Medical equipment",
      imagerie: "Imaging",
      biologie: "Laboratory tests",
      medicationPlaceholder: "Medication (INN) + dosage",
      equipmentPlaceholder: "Medical equipment",
      imagingPlaceholder: "Imaging exam",
      biologyPlaceholder: "Laboratory test",
      medications: "Medications",
      equipment: "Equipment",
      imaging: "Imaging",
      biology: "Biology",
    },
    synthesis: {
      title: "Liaison letter",
      placeholder: "Write the structured liaison letter here...",
      generate: "Generate automatically",
      regenerate: "Regenerate",
      generated: "Liaison letter generated",
      export: "Export to PDF"
    },
    copy: {
      section: "Copy section",
      copied: "Section copied",
      error: "Copy error"
    },
    characterCount: "characters",
    onboarding: {
      title: "Consultation module setup",
      description: "To optimize your experience, please complete your professional information. This data will improve automatic document generation and billing.",
      professionalInfo: "Professional information",
      proPhone: "Professional phone",
      phonePlaceholder: "01 23 45 67 89",
      proEmail: "Professional email",
      emailPlaceholder: "doctor@practice.com",
      proAddress: "Professional address",
      proAddressPlaceholder: "Complete address of your medical practice...",
      rpps: "RPPS number",
      rppsPlaceholder: "12345678901",
      benefits: {
        title: "Benefits of this information:",
        letters: "Personalized liaison letters",
        documents: "Pre-filled official documents"
      },
      skip: "Skip for now",
      save: "Save and continue",
      saving: "Saving...",
      saved: "Professional information saved",
      privacy: "This information is stored securely and is only used to improve your experience."
    },
    editor: {
      draftCreated: "Draft created automatically",
      draftError: "Error creating draft",
      codeRequired: "Code is required",
      ocrTextAdded: "Extracted text from documents added",
      noTextForAI: "No text available for AI analysis",
      largeTextWarning: "Large text detected - Automatic compression in progress...",
      pdfError: "Error generating PDF",
      printWindowError: "Unable to open print window",
      codeCopied: "{{type}} code copied"
    }
  },
  
  es: {
    // Navegación y páginas
    consultations: "Consultas",
    newConsultation: "Nueva consulta",
    editConsultation: "Editar consulta",
    patientDetails: "Detalles del paciente", 
    patientNotFound: "Paciente no encontrado",
    
    // Información del paciente
    patientInfo: "Información del paciente",
    birthDate: "Fecha de nacimiento",
    phone: "Teléfono",
    email: "Email",
    address: "Dirección", 
    attendingPhysician: "Médico tratante",
    
    // Página de consultas
    seoTitle: "Gestión de Consultas - Sclépios I.A",
    seoDesc: "Gestione sus pacientes y consultas médicas con el asistente IA Sclépios",
    myPatients: "Mis Pacientes",
    newPatient: "Nuevo Paciente",
    newPatientShort: "Nuevo",
    searchPatient: "Buscar un paciente...",
    results: "{{count}} resultado(s)",
    filters: "Filtros",
    noPatientFound: "No se encontró ningún paciente",
    noPatientRegistered: "No hay pacientes registrados",
    tryModifySearch: "Intente modificar su búsqueda",
    addFirstPatient: "Comience agregando su primer paciente",
    addPatient: "Agregar un paciente",
    
    // Cotaciones
    cim10Title: "Códigos CIM-10 (Diagnósticos)",
    ccamTitle: "Códigos CCAM (Actos)",
    codePlaceholder: "Código {{type}}",
    labelPlaceholder: "Denominación",
    
    // Estado
    status: {
      brouillon: "Borrador",
      terminé: "Completado"
    },
    
    // Acciones
    createFirst: "Crear primera consulta",
    noConsultations: "No hay consultas registradas",
    consultationsDescription: "Historial de consultas para este paciente",
    confirmDelete: "¿Está seguro de que desea eliminar esta consulta?",
    deleted: "Consulta eliminada",
    saved: "Consulta guardada",
    codeAdded: "Código {{type}} agregado",
    codeRemoved: "Código {{type}} eliminado",
    updated: "Consulta actualizada",
    loadError: "Error al cargar las consultas",
    loadOneError: "Error al cargar la consulta",
    deleteError: "Error al eliminar la consulta",
    saveError: "Error al guardar la consulta",
    complete: "Completar",
    labelOptional: "Etiqueta (opcional)",
    justificationOptional: "Justificación (opcional)",
    addCode: "Agregar código {{type}}",
    usualTreatment: "Tratamiento habitual",
    cim10Code: "CIE-10",
    
    // Secciones de consulta
    freeText: "Texto libre", 
    freeTextPlaceholder: "Ingrese aquí sus notas de consulta...",
    history: "Historia de la enfermedad",
    historyPlaceholder: "Motivo de consulta, evolución de síntomas...",
    background: "Antecedentes",
    backgroundPlaceholder: "Antecedentes médicos, quirúrgicos, familiares...",
    clinicalObservation: "Observación clínica",
    clinicalObservationPlaceholder: "Examen físico, signos clínicos...",
    paraclinicalResults: "Resultados paraclínicos",
    paraclinicalResultsPlaceholder: "Exámenes complementarios, análisis...",
    conclusions: "Conclusiones y prescripciones",
    conclusionsPlaceholder: "Diagnóstico, tratamiento, recomendaciones...",
    
    // IA y transcripción
    analyzeWithAI: "Analizar con IA",
    noTextToAnalyze: "No hay texto para analizar",
    
    // Entry tiles
    entryTiles: {
      text: {
        title: "Entrada de texto",
        desc: "Escriba sus notas."
      },
      voice: {
        title: "Dictado por voz", 
        desc: "Toque para dictar; transcribimos."
      },
      photo: {
        title: "Captura de foto",
        desc: "Fotografía un documento; extraemos el texto."
      },
      import: {
        title: "Importar documentos",
        desc: "Importe documentos; texto extraído automáticamente."
      }
    },
    aiAnalysisComplete: "Análisis de IA completado",
    aiAnalysisError: "Error en el análisis de IA",
    audioTranscription: "Transcripción de audio",
    transcriptionAdded: "Transcripción agregada",
    
    // Exportar
    copyText: "Copiar texto",
    printPDF: "Imprimir a PDF",
    copiedToClipboard: "Copiado al portapapeles",
    nothingToCopy: "Nada que copiar",
    
    // New UI translations
    tabs: {
      saisie: 'Entrada',
      structuration: 'Estructura',
      synthese: 'Síntesis'
    },
    actions: {
      analyze: 'Analizar con IA',
      copy: 'Copiar',
      print: 'Imprimir',
      save: 'Guardar',
      complete: 'Completar',
      saveStatus: {
        saving: 'Guardando...',
        saved: 'Guardado',
        offline: 'Modo sin conexión'
      },
      shortcuts: {
        save: 'Ctrl+S para guardar',
        analyze: 'Ctrl+Intro para analizar'
      }
    },
    ocr: {
      extractedText: "Texto extraído por OCR",
      ocrDocument: "Documento OCR"
    },
    offline: {
      available: "Disponible sin conexión",
      notAvailable: "No disponible sin conexión"
    },
    toc: {
      title: "Índice",
      saisieLibre: "Entrada libre",
      voiceRecording: "Transcripción de voz",
      ocr: "Extracción de documento",
      attachments: "Adjuntos",
      histoireMaladie: "Historia de la enfermedad", 
      antecedents: "Antecedentes",
      traitement: "Tratamiento",
      modeVie: "Estilo de vida",
      observation: "Observación",
      priseCharge: "Manejo",
      resultats: "Resultados",
      ordonnances: "Prescripciones",
      cotations: "Codificación",
      conclusion: "Conclusión",
      ccmu: "Clasificación CCMU",
      facturation: "Facturación",
      valorisation: "Valoración",
      courrierLiaison: "Carta de enlace"
    },
    tips: {
      voiceRecording: "Consejo: use grabación de voz para entrada rápida",
      ocrUpload: "Consejo: suba documentos para extracción automática de texto"
    },
    placeholders: {
      freeText: 'Ingrese el motivo de consulta, síntomas, examen clínico...',
      history: 'Describa la evolución de los síntomas, tratamientos anteriores...',
      background: 'Antecedentes médicos, quirúrgicos, familiares...',
      observation: 'Examen físico, signos vitales...',
      management: 'Diagnóstico, plan terapéutico...',
      results: 'Resultados de exámenes complementarios...',
      conclusion: 'Resumen de la consulta, recomendaciones...',
      prescriptions: 'Prescripciones de alta...',
      synthesis: 'Ingrese o genere automáticamente la carta de enlace...',
      antecedentsStructures: 'Agregue antecedentes médicos, quirúrgicos y comorbilidades...',
      traitementHabituel: 'Liste los medicamentos habituales del paciente...',
      modeDeVie: 'Anote hábitos de vida, factores de riesgo...',
      allergies: 'Liste las alergias conocidas del paciente...',
      priseEnCharge: "Tratamiento propuesto, seguimiento, derivación...",
      coding: 'Códigos CIM-10 y CCAM generados por IA...',
    },
    ordonnances: {
      medicaments: "Medicamentos",
      materiel: "Equipo médico",
      imagerie: "Imágenes",
      biologie: "Exámenes de laboratorio",
      medicationPlaceholder: "Medicamento (DCI) + posología",
      equipmentPlaceholder: "Equipo médico",
      imagingPlaceholder: "Examen de imagen",
      biologyPlaceholder: "Examen de laboratorio",
      medications: "Medicamentos",
      equipment: "Equipo",
      imaging: "Imágenes",
      biology: "Biología",
    },
    synthesis: {
      title: "Carta de enlace",
      placeholder: "Escriba aquí la carta de enlace estructurada...",
      generate: "Generar automáticamente",
      regenerate: "Regenerar",
      generated: "Carta de enlace generada",
      export: "Exportar a PDF"
    },
    copy: {
      section: "Copiar sección",
      copied: "Sección copiada",
      error: "Error al copiar"
    },
    characterCount: "caracteres",
    onboarding: {
      title: "Configuración del módulo de consulta",
      description: "Para optimizar su experiencia, complete su información profesional. Estos datos mejorarán la generación automática de documentos y la facturación.",
      professionalInfo: "Información profesional",
      proPhone: "Teléfono profesional",
      phonePlaceholder: "01 23 45 67 89",
      proEmail: "Email profesional",
      emailPlaceholder: "doctor@consultorio.es",
      proAddress: "Dirección profesional",
      proAddressPlaceholder: "Dirección completa de su consultorio médico...",
      rpps: "Número RPPS",
      rppsPlaceholder: "12345678901",
      benefits: {
        title: "Beneficios de esta información:",
        letters: "Cartas de enlace personalizadas",
        documents: "Documentos oficiales pre-llenados"
      },
      skip: "Omitir por ahora",
      save: "Guardar y continuar",
      saving: "Guardando...",
      saved: "Información profesional guardada",
      privacy: "Esta información se almacena de forma segura y solo se utiliza para mejorar su experiencia."
    },
    editor: {
      draftCreated: "Borrador creado automáticamente",
      draftError: "Error al crear el borrador",
      codeRequired: "El código es obligatorio",
      ocrTextAdded: "Texto extraído de documentos agregado",
      noTextForAI: "No hay texto disponible para el análisis IA",
      largeTextWarning: "Texto voluminoso detectado - Compresión automática en curso...",
      pdfError: "Error al generar el PDF",
      printWindowError: "Imposible abrir la ventana de impresión",
      codeCopied: "Código {{type}} copiado"
    }
  }
};